const MONGODB_OBJECTID_REGEX = /^[A-Fa-f0-9]{24}$/;
// eslint-disable-next-line import/prefer-default-export
export const isValid = (value: string) => MONGODB_OBJECTID_REGEX.test(value);
